<script setup lang="ts">
import { StatusMessagePage } from "@/app/registration-app/shared/components";
import LoadingSpinner from "@/shared/components/LoadingSpinner/LoadingSpinner.vue";
import Button from "@/shared/components/Button/Button.vue";
import Icon from "@/shared/components/Icon/Icon.vue";

const { isVerifyingEmail, hasError } = defineProps<{
  isVerifyingEmail: boolean;
  hasError: boolean;
}>();
</script>

<template>
  <template v-if="isVerifyingEmail">
    <div class="verify-email">
      <LoadingSpinner />
      <div class="verify-email--title">
        {{ $t("registration.user.verifyEmail.loading") }}
      </div>
    </div>
  </template>
  <template v-else-if="hasError">
    <StatusMessagePage
      :title="$t('registration.user.verifyEmail.error.invalidLink.title')"
      :text="$t('registration.user.verifyEmail.error.invalidLink.text')"
    />
  </template>
  <template v-else>
    <div class="verify-email">
      <div class="verify-email--icon">
        <Icon
          icon="check"
          :size="64"
        />
      </div>
      <div class="verify-email--title">
        {{ $t("registration.user.verifyEmail.success") }}
      </div>
      <Button
        :caption="$t('shared.action.toLogin')"
        href="/DigitalServicesLogin"
      />
    </div>
  </template>
</template>

<style scoped>
@import "VerifyEmailContainer.css";
</style>
